import type { AgentExecutionOutput } from '~/api/agentLogs/types';
import { formatJsonString } from '~/common/helpers/formatJsonString';

export function formatAgentLogOutput(output: AgentExecutionOutput): string {
  if (output.structured) {
    return formatJsonString(output.structured);
  }

  if (output.body) {
    return formatJsonString(output.body);
  }

  return '';
}
